module.exports = __webpack_public_path__ + "static/img/NSW-17.20f88ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-17.jpg
// module id = 0ANX
// module chunks = 0